import moment from "moment";
import { Loader } from "../loader";
import { useEffect, useState } from "react";
import { handleCurrency, handleTitle } from "../../helper/helper";
import infoBtn from "../../assets/images/info-circle.svg";
import { useNavigate } from "react-router-dom";
import { fetchBuyerRequestList } from "../../action/buyer";
import Pagination from "../../components/pagination/paginationView";
import plusWhite from "../../assets/images/plus-white.svg";
import { SearchBox } from "../SearchBox";
import { Link } from "react-router-dom";


export const BuyerInprogressRequest = () => {
  const navigate = useNavigate();
  const [buyerReuqstList, setBuyerReuqstList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(10);
  const [search, setSearch] = useState("");


  const [status, setStatus] = useState(5);

  const fetchBuyerList = async (searchvalue = "") => {
    setIsLoading(true);
    const response = await fetchBuyerRequestList(
      currentPage,
      paginationValue,
      status,
      "",
      searchvalue
    );
    if (response.status) {
      setBuyerReuqstList(response.data.list);
      setTotalRecords(response.data.count);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchBuyerList(search);
  }, [currentPage, paginationValue, status, search]);

  return (
    <>
      <div className="payout_data-content">
        <div className="payout_data-head">
          <div className="payout_data-head-top">
            <div className="payout_data-left p-0">
              <div className="payout_data_ttl"> {handleTitle()} Request List</div>
            </div>
            {/* <div className="payout_data-right"> */}

            <Link
              color="info"
              tag="a"
              className="btn btn-primary"
              // onClick={handleShow}
              to="/buyerRequest/add"
            >
              Create New
              <img src={plusWhite} alt="" className="payout_down" />
            </Link>
            {/* </div> */}
          </div>
          <div className="search_container mb-4">
            <SearchBox search={search} setSearch={setSearch} />
          </div>
          <div className="new-tab_box">
            <ul className="bidtab">
              <li><Link to="/buyerReqest/pending-request">Pending Requests</Link></li>
              <li><Link to="/buyerReqest/confirmed-request">Confirmed Requests</Link></li>
              <li className="active"><Link to="/buyerReqest/inprogress-request">Inprogress Requests</Link></li>
              <li><Link to="/buyerReqest/closed-request">Closed Requests</Link></li>
            </ul>
          </div>
        </div>
        <div className="overflow_auto">
          <table className="payout_table upi-mandate_table">
            <tr className="tableHead">
              <th className="thHeader">
                <div className="payoutHead hndIcon">Order ID</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead hndIcon">Order Date</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Address</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Product</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Variety</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Grade</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">MSP </div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Price </div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Quantity </div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Total Price </div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Delivery Date</div>
              </th>
              <th className="thHeader">
                <div className="payoutHead">Action </div>
              </th>
            </tr>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="12">
                    <Loader />
                  </td>
                </tr>
              ) : (
                <>
                  {buyerReuqstList.length ? (
                    buyerReuqstList.map((item) => {
                      return (
                        <tr>
                          <td className="noWrap">{item.orderId}</td>
                          <td className="phone_number noWrap">
                            {moment(item?.createdAt).format("DD-MM-YYYY")}
                          </td>
                          <td className="Status address_td">
                            <div>{item?.location}</div>
                          </td>
                          <td className="table_amount">{item?.product}</td>
                          <td className="table_amount noWrap">
                            {item?.veriety ?? "-"}
                          </td>
                          <td className="table_amount">{item?.grade}</td>
                          <td className="Status">
                            <div>
                              {item?.mspDetails?.minimum_selling_price ||
                                ""}
                              / {item?.mspDetails?.unit?.shortcode || ""}
                            </div>
                          </td>
                          <td className="Status bold_txt">
                            <div className="noWrap">
                              {handleCurrency()} {item?.price}
                            </div>
                          </td>
                          <td className="Status bold_txt">
                            <div>
                              {item?.quantity ?? item?.quantity}{" "}
                              {item?.unit}
                            </div>
                          </td>
                          <td nowrap className="Status noWrap bold_txt">
                            {handleCurrency()}{" "}
                            {(item?.price ?? 0) *
                              (item?.quantity ?? 0) *
                              (item?.conversion ?? 0)}
                          </td>
                          <td>
                            <div className="noWrap">
                              {moment(item?.deliveryDate).format(
                                "DD-MM-YYYY"
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="action_payment addBuyer_submit-btn pd_0">
                              <img
                                src={infoBtn}
                                onClick={() => {
                                  navigate(
                                    `/buyerRequest/inprogress/${item._id}`
                                  );
                                }}
                                alt="infoIcon"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <>
                      <tr>
                        <td colspan="11" className="text_center">
                          No data available
                        </td>
                      </tr>
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        {buyerReuqstList?.length > 0 ? (
          <Pagination
            currentPage={currentPage}
            totalCount={totalRecords}
            pageSize={paginationValue}
            onPageChange={(page) => setCurrentPage(page)}
            changePageSize={(page) => {
              setPaginationValue(page);
              setCurrentPage(1);
            }}
          />
        ) : (
          <></>
        )
        }
      </div>
    </>
  );
};